<script>
import CMSListCard from "@/views/components/cms/CMSListCard.vue";

export default {
  name: "RentenClearUpErklaerVideoList",
  components: {CMSListCard},
  data() {
    return {
      tableItems: null,
      tableHeader: [
        {
          title: "article",
          label: "Titel",
        },
        {
          title: "creator",
          label: "Erstellt von",
        },
        {
          title: "description",
          label: "Beschreibung",
        },
        {
          title: "Action",
          label: "Aktionen",
        }
      ]
    };
  },
}
</script>

<template>
  <CMSListCard
      title="Renten Clear-Up Erklärvideo"
      new-button-name="Neue(s) Dokument"
      :list-header="tableHeader"
      :category=8
      :event-to-call-options="{
        table: tableItems,
        showPath: 'RentenClearUpErklaerVideo',
        redirectPath: 'RentenClearUpErklaerVideoEdit',
        categoryId: 8,
        deletePath: 'cms/deleteArticle',
        getPath: 'cms/getArticlesByCategory',
        textDelete: 'Artikel wurde erfolgreich gelöscht!',
        textDefaultData: 'renten clear-up video'
      }"
   new-button-path="RentenClearUpErklaerVideoNew"></CMSListCard>
</template>

<style scoped>

</style>
